<template>
    <table class="table table-hover">
        <tbody>
            <tr v-show="error_message !== ''">
              <th scope="row" colspan="6">
                <span style="font-size: 20px; color: red; text-align: center;">error: {{ error_message }}</span>
              </th>
            </tr>
            <tr>
              <th scope="row" colspan="6">
                <el-popover
                    placement="bottom"
                    title="添加课程习题"
                    width="700"
                    trigger="click"
                    content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
                    >
                    <el-input
                        type="text"
                        placeholder="请输入标题"
                        v-model="title"
                        maxlength="100"
                        show-word-limit
                        >
                    </el-input>
                    <span>题目id:</span>
                    <el-input-number 
                        placeholder="请输入编号"
                        style="margin-top: 10px; margin-left: 10px;" 
                        v-model="pbid" 
                        :min="1" 
                        :max="999" 
                        label="123"
                        >
                    </el-input-number>
                    <div>
                        <el-button type="text" style="margin-left: 290px;" @click="AddCatalogProblem">上传到后端</el-button>
                    </div>
                    <div style="text-align: center; font-size: 30px;" slot="reference"><i class="el-icon-plus hh" style="border: 3px solid black"></i></div>
                </el-popover>
              </th>
            </tr>
            <tr v-for="item in list" :key="item.id">
                <td class="col-2" style="color: #778899; font-size: 16px;">{{ item.title }}</td>
                <td class="col-8" style="color: #589ee4; line-height: 23px;">
                    <span class="hover">AL {{ item.pbid }}. {{ item.problemName }}</span>
                </td>
                <td class="col-2">
                <el-popover
                    placement="bottom"
                    title="修改 / 删除习题"
                    width="700"
                    trigger="click"
                    content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
                    >
                    <el-input
                        type="text"
                        placeholder="请输入标题"
                        v-model="title"
                        maxlength="100"
                        show-word-limit
                        >
                    </el-input>
                    <span>题目id:</span>
                    <el-input-number 
                        placeholder="请输入编号"
                        style="margin-top: 10px; margin-left: 10px;" 
                        v-model="pbid" 
                        :min="1" 
                        :max="999" 
                        label="123"
                        >
                    </el-input-number>
                    <div>
                        <el-button type="text" style="margin-left: 290px;" @click="UpdateCatalog(item.id)">上传到后端</el-button>
                    </div>
                    <el-button slot="reference" type="text" style="margin-left: 10PX;" @click="openUpdate(item)">修改习题</el-button>
                </el-popover>
                <el-button type="text" style="margin-left: 10px;" @click="DeleteCatalog(item.id)">删除</el-button>
              </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
    import $ from 'jquery'
    export default {
        props:["cId"],
        data() {
            return {
                title:'',
                pbid:'',
                catalogId:'',
                error_message:'',

                list:[],
            }
        },
        mounted() {
            // console.log("cid == >", this.cId)
            this.catalogId = this.cId

            this.GetCatalogProblem()
        },
        methods: {
            openUpdate(item) {
                this.title = item.title
                this.pbid = item.pbid
            },
            UpdateCatalog(id) {
                const vue = this
                const store = this.$store

                $.ajax({
                    url:'https://app6132.acapp.acwing.com.cn/api/catalogProblem/update/',
                    type:'post',
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    data: {
                        id: id,
                        title: vue.title,
                        pbid: vue.pbid
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            // console.log("删除课程习题成功了")
                            vue.error_message = ""
                            vue.GetCatalogProblem()
                        } else {
                            vue.error_message = resp.error_message
                        }
                    },
                    error(resp) {
                        console.log("删除课程习题彻底失败了, resp == >", resp)
                    }
                })
            },
            DeleteCatalog(id) {
                const vue = this
                const store = this.$store

                $.ajax({
                    url:'https://app6132.acapp.acwing.com.cn/api/catalogProblem/delete/',
                    type:'post',
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    data: {
                        id: id,
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            // console.log("修改课程习题成功了")
                            vue.error_message = ""
                            vue.GetCatalogProblem()
                        } else {
                            vue.error_message = resp.error_message
                        }
                    },
                    error(resp) {
                        console.log("修改课程习题彻底失败了, resp == >", resp)
                    }
                })
            },
            AddCatalogProblem() {
                const vue = this
                const store = this.$store

                $.ajax({
                    url:'https://app6132.acapp.acwing.com.cn/api/catalogProblem/create/',
                    type:'post',
                    headers: {
                        Authorization: "Bearer " + store.state.me.token,
                    },
                    data: {
                        pbid: vue.pbid,
                        title: vue.title,
                        catalogId: vue.cId
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            // console.log("添加课程习题成功了")
                            vue.pbid = 1
                            vue.title = ""
                            vue.error_message = ""
                            vue.GetCatalogProblem()
                        } else {
                            vue.error_message = resp.error_message
                        }
                    },
                    error(resp) {
                        console.log("添加课程习题彻底失败了, resp == >", resp)
                    }
                })
            },
            GetCatalogProblem() {
                const vue = this

                $.ajax({
                    url:'https://app6132.acapp.acwing.com.cn/api/catalogProblem/read/',
                    type:'post',
                    data: {
                        catalogId: vue.cId
                    },
                    success(resp) {
                        if (resp.error_message === "success") {
                            // console.log("获取课程习题成功了")
                            vue.error_message = ""
                            vue.list = JSON.parse(resp.catalogProblem);
                            // console.log(vue.list)
                        } else {
                            vue.error_message = resp.error_message
                            vue.list = []
                        }
                    },
                    error(resp) {
                        console.log("获取课程习题彻底失败了, resp == >", resp)
                    }
                })
            }
            // ClickMeToSearch() {
            //     this.$store.dispatch("problem/SelectQuestionList", {
            //         list: "",
            //         option: "",
            //         input: this.input,
            //         pbfrom: "1",
            //     })
            // }
        }
    }
</script>

<style>

</style>